import React, { useState } from "react";
import styled, { css } from "styled-components";
import { isEmpty } from "../../util/util";

// Styled Components
const DetailsWrapper = styled.div`
	width: 100%;
	margin: 0 auto;
	overflow: hidden;
	border-radius: 0.5rem;
	background-color: ${(props) => (props.isExpanded ? "#FFF" : "")};
	max-height: ${props => props.isExpanded ? "300rem" : "56px"};
	transition: max-height 0.5s cubic-bezier(0, 1, 0, 1), background-color 0.3s ease-in-out;
`;

const DetailsHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem;
	transition: background-color 0.3s ease;

	&:hover {
		${(props) =>
			!props.disableCollapse &&
			css`
				cursor: pointer;
			`}
	}
`;

const DetailsTitle = styled.h2`
	font-size: 1.125rem;
	font-weight: 900;
	color: #000;
`;

const DetailsContent = styled.div`
	padding: ${(props) => (props.isList ? "0 1rem 1rem 1rem" : "0 0.5rem 0.5rem 0.5rem")};
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	border-radius: 0.5rem;
`;

const ChildGrid = styled.div`
	display: flex;
	flex-direction: ${(props) => (props.isList ? "column" : "row")};
	flex-wrap: wrap;
	align-items: ${(props) => (props.isList ? "" : "center")};
	gap: ${(props) => (props.isList ? "1rem" : "0.5rem")};
`;

const ChildWrapper = styled.div`
	flex: 0 1 calc(25% - 1rem);

	@media (max-width: 1024px) {
		flex: 0 1 calc(33.333% - 1rem);
		max-width: calc(33.333% - 1rem);
	}

	@media (max-width: 768px) {
		flex: 0 1 calc(50% - 1rem);
		max-width: calc(50% - 1rem);
	}

	@media (max-width: 640px) {
		flex: 0 1 100%;
		max-width: 100%;
	}
`;

const Chevron = ({ isExpanded }) => (
	<span
		className={isExpanded ? "material-symbols-outlined rotate-up" : "material-symbols-outlined"}
		style={{ cursor: "pointer" }}>
		keyboard_arrow_down
	</span>
);

const DetailsComponent = ({ title, children, initiallyExpanded = false, disableCollapse, isList }) => {
	if (isEmpty(children)) disableCollapse = true;

	const expanded = initiallyExpanded || disableCollapse;
	const [isExpanded, setIsExpanded] = useState(expanded);

	return (
		<DetailsWrapper isExpanded={isExpanded}>
			<DetailsHeader
				disableCollapse={disableCollapse}
				onClick={() => {
					if (disableCollapse) return;
					setIsExpanded(!isExpanded);
				}}>
				<DetailsTitle>{title}</DetailsTitle>
				{disableCollapse ? "" : <Chevron isExpanded={isExpanded} />}
			</DetailsHeader>

			<DetailsContent isList={isList}>
				<ChildGrid isList={isList}>
					{React.Children.map(children, (child, index) => (
						<ChildWrapper key={index}>{child}</ChildWrapper>
					))}
				</ChildGrid>
			</DetailsContent>
		</DetailsWrapper>
	);
};

export default DetailsComponent;
